.link {
  display: inline-flex;
  gap: calc(var(--mantine-spacing-md) * 0.25);
  align-items: center;
  max-width: 100%;
}

.icon {
  flex-shrink: 0;
  color: var(--mantine-color-blue-6);
}

.truncate {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[data-mantine-color-scheme='dark'] .icon {
  color: var(--mantine-color-blue-4);
}
